import {useEffect, useLayoutEffect, useRef, useState} from "react";
import {setupEvents} from './events';
import {VastType} from "../getSources";

export type VPaidProps = {
    scriptUrl: string,
    complete: (hasError: string) => void,
    adStart: (duration: number) => void,
    adPause: (f: (()=>void)|undefined)=>void,
    width: () => number,
    height: () => number,
    volume: number,
    className: string,
    vast: VastType,
    adLoad: ()=>void
}


const VPaid = (props: VPaidProps) => {
    const [width, height] = ([props.width(), props.height()]);

    const rIframe = useRef<HTMLIFrameElement | null>(null)

    const getVPaid = useRef<any | null>(null);
    const volume = useRef<number>(props.volume);

    const getVolume = () => {
        return volume.current;
    }

    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState<any>(null)
    const children = useRef<{
        video: HTMLVideoElement,
        containerAd: HTMLDivElement,
        childDocument: Document,
        contentWindow: Window
    } | null>(null);

    useEffect(() => {
        if (error) {
            props.complete(`${error}`)
        }
    }, [error]);

    useLayoutEffect(() => {

        try {
            const frame = rIframe.current as HTMLIFrameElement;
            const contentWindow = frame.contentWindow as Window;
            const childDocument = contentWindow?.document ?? frame.contentDocument;

            const video = childDocument.createElement('video')
            const containerAd = childDocument.createElement('div')
            childDocument.body.appendChild(containerAd);
            containerAd.appendChild(video);
            containerAd.id = 'container-vpaid';
            containerAd.style.position = "relative";
            video.id = 'video-vpaid';
            video.height = 10;
            video.width = 10;
            video.style.position="absolute";
            video.style.top = "0px";
            video.style.left = "0px";
            video.style.width = (props.width() || 10) + 'px';
            video.style.height = (props.height() || 10) + 'px';
            video.playsInline = true;
            video.volume = 0.05;
            children.current = {
                video,
                contentWindow,
                containerAd,
                childDocument
            }
        }
        catch (e) {
            setError(e);
        }
        // eslint-disable-next-line
    }, []);

    useLayoutEffect(() => {
        try {
            let nothing = false;
            let waiting: number;

            if (props.vast !== "NONE") {
                if (children.current) {

                    const {contentWindow, childDocument, containerAd, video} = children.current;

                    waiting = setTimeout(i => {
                        nothing = true;
                        props.complete('vpaidElement: timeout');
                    }, 4000);
                    let vpaidLoader = childDocument.createElement('script');
                    vpaidLoader.onload = function () {

                        if (nothing)
                            return;
                        // @ts-ignore
                        getVPaid.current = contentWindow.getVPAIDAd();
                        clearTimeout(waiting);
                        setupEvents({
                            vpaid: getVPaid.current,
                            containerAd: containerAd,
                            video: video,
                            width: props.width(),
                            height: props.height(),
                            vast: props.vast,
                            adLoad: props.adLoad,
                            complete: props.complete,
                            adPause: (f) => props.adPause(f),
                            adStart: () => {
                                let duration = 0;
                                if (getVPaid.current && getVPaid.current.getAdDuration) {
                                    duration = getVPaid.current.getAdDuration()
                                }
                                props.adStart(duration)
                            },
                            getVolume: getVolume
                        });
                        setLoaded(true);
                    };

                    vpaidLoader.src = props.scriptUrl;
                    childDocument.body.appendChild(vpaidLoader);
                    return;
                }
                props.complete('vpaidElement: creatingError');
            }
        }
        catch (e) {
            setError(e);
        }
        // eslint-disable-next-line
    }, [props.vast]);

    useEffect(() => {
        if (loaded && getVPaid.current && getVPaid.current.setAdVolume)

            try {
                volume.current = props.volume;
                getVPaid.current?.setAdVolume(props.volume);
            } catch (e) {

            }
    }, [props.volume, loaded]);

    useEffect(() => {
        if (rIframe.current) {
            rIframe.current.style.width = width + 'px';
            rIframe.current.style.height = height + 'px';
            rIframe.current.width = `${width}`;
            rIframe.current.height = `${height}`;
        }
        if (children.current) {
            const {video} = children.current;
            video.height = height;
            video.width = width;
            video.style.width = (width || 10) + 'px';
            video.style.height = (height || 10) + 'px';
        }
        if (getVPaid.current && getVPaid.current.resizeAd) {
            getVPaid.current.resizeAd(width, height, "normal");
        }
        // eslint-disable-next-line
    }, [width, height]);

    return <iframe id={"radiacz-reklama"} title={'radiacz-reklama'} ref={el => rIframe.current = el}
                   className={props.className}
                   style={{
                       width: props.width() + 'px',
                       height: props.height() + 'px'
                   }}
                   width={props.width()}
                   height={props.height()}

                   marginWidth={0}
                   marginHeight={0}
                   frameBorder={0}
                   scrolling="no"
    >content</iframe>

}

export default VPaid;